import http from "../../../Utils/http";

    export function PharmacyPayoutData(data) {
      return http.get(`api/pharmacy/payouts?paid=${data.paid}&page=${data.no}`);
    }

    export function LaboratoryPayoutData(data) {
      return http.get(`api/laboratory/payouts?paid=${data.paid}&page=${data.no}`);
    }